import PropTypes from 'prop-types';
import Image from 'next/image';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import React from 'react';

import { closeModal } from 'features/utilsSlice';
import useModalOpen from 'hooks/useModalOpen';
import CongratulationsImage from 'public/images/congratulations.svg';
import TransitionDialog from 'components/TransitionDialog';
import styles from 'styles/components/Congratulations.module.scss';

const useStyles = makeStyles(theme => ({
  paper: {
    width: '100%',
    height: '100%',
  },

  paperFullWidth: {
    [theme.breakpoints.up('sm')]: {
      width: '100%',
      height: '100%',
    },
  },
}));

const noBottomMargin = { marginBottom: 0 };
const width = { width: 'fit-content' };

const FullScreenDialog = ({ title, subtitle, description, btnText, handleClick, iconSrc, alt }) => {
  const open = useModalOpen('Full Screen');
  const dispatch = useDispatch();
  const classes = useStyles();

  const handleClose = () => {
    dispatch(closeModal('Full Screen'));
    handleClick();
  };

  const fullWidth = { width: '100%' };

  return (
    <TransitionDialog
      open={open}
      handleClose={handleClose}
      paperProps={{ className: classes.paper }}
      dialogStyles={classes.paperFullWidth}
      direction="left"
      desktopDirection="left"
      noCloseIcon
    >
      <div className={styles.congratulations} style={{ height: '100%' }}>
        <div className={styles.title}>
          <CongratulationsImage />

          <h3>{title.toUpperCase()}</h3>

          <h2 style={noBottomMargin}>{subtitle}</h2>

          <p>{description}</p>
        </div>

        <div className={styles.buttons}>
          <Button
            onClick={handleClose}
            variant="contained"
            color="primary"
            style={iconSrc ? width : fullWidth}
            endIcon={
              iconSrc ? <Image src={iconSrc} alt={alt} width={24} height={24} unoptimized /> : false
            }
            fullWidth
          >
            {btnText}
          </Button>
        </div>
      </div>
    </TransitionDialog>
  );
};

FullScreenDialog.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  btnText: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  iconSrc: PropTypes.string,
  alt: PropTypes.string,
  description: PropTypes.string,
};

FullScreenDialog.defaultPropTypes = {
  iconSrc: '',
  alt: '',
  description: '',
};

export default FullScreenDialog;
